export default function MarginVerticalIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1 1.5L13 1.5' stroke='#848484' />
      <path d='M1 12.5L13 12.5' stroke='#848484' />
      <path d='M9.5 9.5L9.5 4.5L4.5 4.5L4.5 9.5L9.5 9.5Z' stroke='#848484' />
    </svg>
  );
}
